@if (msisdnList.length > 1 && visibility) {
  <div class="modal-lines-list" id="list-wrapper">
    <div id="content" class="text-center">
      <div class="search-field">
        <input type="text" placeholder="Nom/Prénom/N°" (keyup)="filter($event)">
      </div>
      <ul class="list-group">
        @for (msisdn of msisdnListCopy; track msisdn) {
          <li class="list-group-item" (click)="setSelectedLine(msisdn.phoneNumber)">
            <div>
              <p>{{ msisdn.phoneNumber }}</p>
              <span>{{ msisdn.titular ? ' : ' + msisdn.titular : '' }}</span>
              <app-dot [dynamicStatus]="msisdn.status"></app-dot>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
}
@if (msisdnList.length > 1 && visibility) {
  <div class="modal-lines-list-background" (click)="closeLinesList($event)"></div>
}
